import { I13VENTCHAUFFIOUL_State } from '@batical/types/src'

const I13VENTCHAUFFIOUL: I13VENTCHAUFFIOUL_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_puissanceTotal: 1000.0,
  res_VH: 0.0,
  res_VB: 0.0,
  res_diamVH: 0.0,
  res_diamVB: 0.0,
  res_longeurVH: 0.0,
  res_longeurVB: 0.0,
  in_longeurVH: 447.0,
  res_hauteurVH: 0.0,
  in_longeurVB: 547.0,
  res_largeurVB: 0.0,
  mode: 'none',
  calcul_code: 'I13VENTCHAUFFIOUL'
}

export default I13VENTCHAUFFIOUL
